// External Modules
import { lazy, useEffect } from 'react';
import { Outlet, Routes, Route, useLocation } from 'react-router-dom';

// Internal Modules
import loadSdk, { decodeBase64, people, reportError } from '@apolitical/sdk';
import { GlobalProviders, PageLayout } from '@apolitical/component-library';

// Styles
import '@apolitical/component-library/style.css';

// Pages
const CookiePolicyPage = lazy(() => import('./Pages/CookiePolicy'));
const SpecialContent = lazy(() => import('./Pages/SpecialContent'));
const GrowthReferral = lazy(() => import('./Pages/GrowthReferral'));

const messages = require('../locales/en.json');

function App(props) {
  const location = useLocation();

  async function bootstrap() {
    // Load the SDK
    loadSdk({
      contentContext: {
        apiKey: decodeBase64(process.env.REACT_APP_CDA_API_KEY),
        previewKey: decodeBase64(process.env.REACT_APP_CPA_API_KEY),
        location,
      },

      errorsContext: {
        apiKey: decodeBase64(process.env.REACT_APP_GCP_ERRORS_API_KEY),
        serviceName: 'general-pages-ui',
      },
      gtmContext: {
        configs: JSON.parse(decodeBase64(process.env.REACT_APP_GTM_ID)),
      },
      origin: window.origin || window.location.origin,
    });
    // Fetch logged-in user (/me)
    const me = await people.users.read('me');
    // It must return the user object
    return me;
  }

  // TODO: delete this when we remove the privacy and terms routes
  const Redirect = ({ url }) => {
    useEffect(() => {
      window.location.replace(url);
    }, []);
    return null;
  };

  return (
    <GlobalProviders bootstrap={bootstrap} intl={{ messages }}>
      <Routes>
        <Route path="/privacy-policy" element={<Redirect url="https://about.apolitical.co/privacy-policy" />} />
        <Route
          path="/terms-and-conditions"
          element={<Redirect url="https://about.apolitical.co/terms-and-conditions" />}
        />

        <Route
          element={
            <PageLayout
              reportError={reportError}
              suprSendWorkspaceKey={process.env.REACT_APP_SUPRSEND_WORKSPACE_KEY}
            >
              <Outlet />
            </PageLayout>
          }
        >
          <Route path="/cookie-policy" element={<CookiePolicyPage />} />
          <Route path="/referral" element={<GrowthReferral />} />
          <Route path="/:slug" element={<SpecialContent res={props.res} />} />
        </Route>
      </Routes>
    </GlobalProviders>
  );
}

App.defaultProps = {
  res: false,
  cookies: false,
};

export default App;
